/* BrainBash Events — shared JS */
(function() {
  'use strict';

  var TYPE_ICONS = {
    'Spielenachmittag': '🎮',
    'Verkaufsstand':    '🛒',
    'Messe':            '🏛️',
    'Livestream':       '📺'
  };

  var MONTHS_DE = ['','Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'];

  function getIcon(type) {
    if (!type) return '📅';
    for (var k in TYPE_ICONS) {
      if (type.toLowerCase().indexOf(k.toLowerCase()) > -1) return TYPE_ICONS[k];
    }
    return '📅';
  }

  function parseDate(dtStr) {
    if (!dtStr) return null;
    return new Date(dtStr);
  }

  function fmtDate(dt) {
    if (!dt) return '';
    return dt.getDate() + '. ' + MONTHS_DE[dt.getMonth() + 1] + ' ' + dt.getFullYear();
  }

  function fmtTime(dt) {
    if (!dt) return '';
    return dt.getHours() + ':' + String(dt.getMinutes()).padStart(2, '0') + ' Uhr';
  }

  function toICSDate(dt) {
    if (!dt) return '';
    return dt.getFullYear() +
      String(dt.getMonth() + 1).padStart(2,'0') +
      String(dt.getDate()).padStart(2,'0') + 'T' +
      String(dt.getHours()).padStart(2,'0') +
      String(dt.getMinutes()).padStart(2,'0') + '00';
  }

  function buildGCalURL(ev) {
    var start = toICSDate(ev._start);
    var end   = toICSDate(ev._end || ev._start);
    return 'https://calendar.google.com/calendar/render?' + new URLSearchParams({
      action: 'TEMPLATE', text: ev.title || '',
      dates: start + '/' + end,
      details: ev.description || '',
      location: ev.address || ev.location || ''
    }).toString();
  }

  function buildICS(ev) {
    return [
      'BEGIN:VCALENDAR','VERSION:2.0','CALSCALE:GREGORIAN','BEGIN:VEVENT',
      'DTSTART:' + toICSDate(ev._start),
      'DTEND:'   + toICSDate(ev._end || ev._start),
      'SUMMARY:' + (ev.title || ''),
      'DESCRIPTION:' + (ev.description || ''),
      'LOCATION:' + (ev.address || ev.location || ''),
      'END:VEVENT','END:VCALENDAR'
    ].join('\r\n');
  }

  function downloadICS(ev) {
    var blob = new Blob([buildICS(ev)], { type: 'text/calendar;charset=utf-8' });
    var url  = URL.createObjectURL(blob);
    var a    = document.createElement('a');
    a.href = url;
    a.download = (ev.title || 'event').replace(/\s+/g,'-') + '.ics';
    a.click();
    URL.revokeObjectURL(url);
  }

  // ── Load + parse ──────────────────────────────────────
  var dataEl = document.getElementById('bb-events-data');
  if (!dataEl) return;
  var raw = JSON.parse(dataEl.textContent);
  var today = new Date(); today.setHours(0,0,0,0);

  var events = raw
    .map(function(ev) {
      ev._start = parseDate(ev.start_dt);
      ev._end   = parseDate(ev.end_dt);
      return ev;
    })
    .filter(function(ev) {
      if (!ev._start) return false;
      var endDate = new Date(ev._end || ev._start); endDate.setHours(23,59,59);
      return endDate >= today;
    })
    .sort(function(a,b) { return a._start - b._start; });

  var limit = window.bbEventsLimit || null;
  var shown = limit ? events.slice(0,limit) : events;

  // ── Render cards ──────────────────────────────────────
  var grid   = document.getElementById('bb-events-grid');
  var noneEl = document.getElementById('bb-events-none');
  if (!grid) return;

  if (shown.length === 0) {
    if (noneEl) noneEl.style.display = 'block';
    return;
  }

  shown.forEach(function(ev, i) {
    var icon = getIcon(ev.event_type);
    var startDay = ev._start ? ev._start.getDate() : '?';
    var startMon = ev._start ? MONTHS_DE[ev._start.getMonth()+1] : '';
    var isReg    = localStorage.getItem('bb-ev-reg-' + ev.handle);
    var hasReg   = (ev.registration === true || ev.registration === 'true') && ev.reg_url && ev.reg_url !== 'null' && ev.reg_url !== '';

    // Date block — multi-day: show "15 Jun BIS 17 Jun"
    var dateHTML;
    var isMultiDay = ev._end && ev._end.toDateString() !== ev._start.toDateString();
    if (isMultiDay) {
      var endDay = ev._end.getDate();
      var endMon = MONTHS_DE[ev._end.getMonth()+1];
      dateHTML =
        '<div class="bb-event-card__day">' + startDay + '</div>' +
        '<div class="bb-event-card__month">' + startMon + '</div>' +
        '<div class="bb-event-card__date-sep">bis</div>' +
        '<div class="bb-event-card__day">' + endDay + '</div>' +
        '<div class="bb-event-card__month">' + endMon + '</div>';
    } else {
      dateHTML =
        '<div class="bb-event-card__day">' + startDay + '</div>' +
        '<div class="bb-event-card__month">' + startMon + '</div>';
    }

    // Time string
    var timeStr = ev._start ? fmtTime(ev._start) : '';
    if (ev._end && ev.end_dt && !isMultiDay) {
      timeStr += ' – ' + fmtTime(ev._end);
    }

    var card = document.createElement('div');
    card.className = 'bb-event-card';
    card.style.transitionDelay = (i * 0.08) + 's';
    card.innerHTML =
      '<div class="bb-event-card__date">' + dateHTML + '</div>' +
      '<div class="bb-event-card__info">' +
        '<div class="bb-event-card__type-row">' +
          '<span class="bb-event-card__type-icon">' + icon + '</span>' +
          '<span class="bb-event-card__type">' + (ev.event_type || '') + '</span>' +
        '</div>' +
        '<p class="bb-event-card__title">' + (ev.title || '') + '</p>' +
        '<div class="bb-event-card__meta">' +
          (timeStr ? '<span>&#128336; ' + timeStr + '</span>' : '') +
          (ev.location ? '<span>&#128205; ' + ev.location + '</span>' : '') +
          (ev.address  ? '<span class="bb-event-card__address" data-addr="' + encodeURIComponent(ev.address) + '">&#128506;&#65039; ' + ev.address + '</span>' : '') +
        '</div>' +
        // External action buttons
        '<div class="bb-event-card__actions">' +
          '<button class="bb-ev-card-btn bb-ev-card-btn--cal" data-idx="' + i + '" title="Im Kalender speichern">' +
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>' +
            'Kalender' +
          '</button>' +
          (hasReg ?
            '<a class="bb-ev-card-btn bb-ev-card-btn--reg' + (isReg ? ' registered' : '') + '" href="' + (ev.reg_url||'#') + '" target="_blank" data-handle="' + ev.handle + '">' +
              (isReg ? '&#10003; Angemeldet' : '+ Anmelden') +
            '</a>'
          : '') +
        '</div>' +
      '</div>';

    // Calendar button dropdown
    card.querySelector('.bb-ev-card-btn--cal').addEventListener('click', function(e) {
      e.stopPropagation();
      showCalDropdown(ev, e.currentTarget);
    });

    // Registration button — mark as registered on click
    var regBtn = card.querySelector('.bb-ev-card-btn--reg');
    if (regBtn) {
      regBtn.addEventListener('click', function() {
        localStorage.setItem('bb-ev-reg-' + ev.handle, '1');
        this.classList.add('registered');
        this.textContent = '✓ Angemeldet';
      });
    }

    // Click card body → open modal
    card.addEventListener('click', function(e) {
      if (e.target.classList.contains('bb-event-card__address')) {
        e.stopPropagation();
        window.open('https://www.google.com/maps/search/?api=1&query=' + e.target.dataset.addr, '_blank');
        return;
      }
      if (e.target.closest('.bb-event-card__actions')) return;
      openModal(ev);
    });

    grid.appendChild(card);
  });

  // Reveal animation
  setTimeout(function() {
    grid.querySelectorAll('.bb-event-card').forEach(function(c) { c.classList.add('is-visible'); });
  }, 80);

  // ── Calendar dropdown ─────────────────────────────────
  var calDropdown = null;
  function showCalDropdown(ev, anchor) {
    if (calDropdown) { calDropdown.remove(); calDropdown = null; }
    var d = document.createElement('div');
    d.className = 'bb-ev-cal-dropdown';
    d.innerHTML =
      '<a href="' + buildGCalURL(ev) + '" target="_blank" class="bb-ev-cal-dropdown__item">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style="color:#4285f4"><path d="M21.56 10.738l-9.56-9.56a3.048 3.048 0 00-4.308 0L2.178 6.692A3.048 3.048 0 002.178 11l9.56 9.56a3.048 3.048 0 004.308 0l5.514-5.514a3.048 3.048 0 000-4.308zM12 15.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7z"/></svg>' +
        'Google Kalender' +
      '</a>' +
      '<button class="bb-ev-cal-dropdown__item bb-ev-ical-dl">'+
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>' +
        'iCal / Apple Kalender' +
      '</button>';
    d.querySelector('.bb-ev-ical-dl').addEventListener('click', function() {
      downloadICS(ev); d.remove(); calDropdown = null;
    });
    calDropdown = d;
    document.body.appendChild(d);
    var r = anchor.getBoundingClientRect();
    d.style.top  = (r.bottom + window.scrollY + 4) + 'px';
    d.style.left = (r.left  + window.scrollX) + 'px';
    setTimeout(function() {
      document.addEventListener('click', function dismiss() {
        d.remove(); calDropdown = null;
        document.removeEventListener('click', dismiss);
      });
    }, 10);
  }

  // ── Modal ─────────────────────────────────────────────
  var backdrop  = document.getElementById('bb-ev-backdrop');
  var currentEv = null;

  function openModal(ev) {
    currentEv = ev;
    var icon = getIcon(ev.event_type);
    var isMultiDay = ev._end && ev._end.toDateString() !== ev._start.toDateString();
    var dateLabel = fmtDate(ev._start);
    if (isMultiDay) dateLabel += ' bis ' + fmtDate(ev._end);

    document.getElementById('bb-ev-m-date').innerHTML = icon + ' ' + dateLabel;
    document.getElementById('bb-ev-m-title').textContent = ev.title || '';
    document.getElementById('bb-ev-m-type').innerHTML = '<span>' + icon + '</span><span>' + (ev.event_type || '') + '</span>';

    var timeStr = ev._start ? fmtTime(ev._start) : '';
    if (ev._end && ev.end_dt && !isMultiDay) timeStr += ' – ' + fmtTime(ev._end);

    var infoHTML = '';
    if (timeStr) infoHTML += '<div class="bb-ev-modal__info-item"><div class="bb-ev-modal__info-label">Uhrzeit</div><div class="bb-ev-modal__info-val">&#128336; ' + timeStr + '</div></div>';
    if (ev.location) infoHTML += '<div class="bb-ev-modal__info-item"><div class="bb-ev-modal__info-label">Veranstaltungsort</div><div class="bb-ev-modal__info-val">&#128205; ' + ev.location + '</div></div>';
    if (ev.address) {
      var mUrl = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(ev.address);
      infoHTML += '<div class="bb-ev-modal__info-item" style="grid-column:1/-1"><div class="bb-ev-modal__info-label">Adresse</div><div class="bb-ev-modal__info-val bb-ev-modal__info-val--link" onclick="window.open(\'' + mUrl + '\',\'_blank\')">&#128506;&#65039; ' + ev.address + ' <span style="font-size:0.7rem;opacity:0.6;">(In Maps öffnen)</span></div></div>';
    }
    document.getElementById('bb-ev-m-info').innerHTML = infoHTML;

    var descEl = document.getElementById('bb-ev-m-desc');
    if (ev.description) { descEl.textContent = ev.description; descEl.style.display = 'block'; }
    else { descEl.style.display = 'none'; }

    // Calendar buttons in modal
    document.getElementById('bb-ev-gcal').href = buildGCalURL(ev);
    document.getElementById('bb-ev-ical').onclick = function() { downloadICS(ev); };

    // Registration — show for ALL types if reg_url is set
    var regSec = document.getElementById('bb-ev-reg');
    var regKey = 'bb-ev-reg-' + ev.handle;
    var isReg  = localStorage.getItem(regKey);

    if ((ev.registration === true || ev.registration === 'true') && ev.reg_url && ev.reg_url !== 'null' && ev.reg_url !== '') {
      regSec.style.display = 'block';
      document.getElementById('bb-ev-reg-already').style.display = isReg ? 'block' : 'none';
      document.getElementById('bb-ev-reg-cta').style.display     = isReg ? 'none'  : 'block';
      document.getElementById('bb-ev-reg-no-msg').style.display  = 'none';
      var yesBtn = document.getElementById('bb-ev-reg-yes');
      yesBtn.href = ev.reg_url;
      yesBtn.onclick = function() {
        localStorage.setItem(regKey, '1');
        document.getElementById('bb-ev-reg-already').style.display = 'block';
        document.getElementById('bb-ev-reg-cta').style.display = 'none';
        // Update card badge
        if (grid) grid.querySelectorAll('.bb-ev-card-btn--reg').forEach(function(btn) {
          if (btn.dataset.handle === ev.handle) {
            btn.classList.add('registered');
            btn.textContent = '✓ Angemeldet';
          }
        });
      };
    } else {
      regSec.style.display = 'none';
    }

    backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
    history.pushState({ bbEvModal: true }, '');
  }

  function closeModal() {
    if (!backdrop || !backdrop.classList.contains('open')) return;
    backdrop.classList.remove('open');
    document.body.style.overflow = '';
    if (history.state && history.state.bbEvModal) history.back();
  }

  var closeBtn = document.getElementById('bb-ev-close');
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (backdrop) backdrop.addEventListener('click', function(e) { if (e.target === backdrop) closeModal(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeModal(); });
  window.addEventListener('popstate', function() {
    if (backdrop && backdrop.classList.contains('open')) {
      backdrop.classList.remove('open'); document.body.style.overflow = '';
    }
  });
  var noBtn = document.getElementById('bb-ev-reg-no');
  if (noBtn) noBtn.addEventListener('click', function() {
    document.getElementById('bb-ev-reg-cta').style.display = 'none';
    document.getElementById('bb-ev-reg-no-msg').style.display = 'block';
  });

})();
